<template>
  <div class="content">
    <h1>Deposits</h1>
    <div
      v-if="loading">
      Loading...
    </div>
    <div
      class="margin-top"
      v-else>
      <table>
        <thead>
          <tr>
            <th>Order</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in data.deposits">
            <td>
              <OrderLink :id="row.id" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";

  export default {
    data: () => ({
      data: {},
      loading: false
    }),
    methods: {
      load () {
        Vue.$api.get('/deposits', {}, {
          before: () => this.loading = true,
          always: () => this.loading = false,
          callback: data => this.data = data
        })
      }
    },
    created() {
      this.load()
    }
  }
</script>
